import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const WarningBanner: React.FC = () => {
  return (
    <div className="bg-yellow-600 text-white py-1 px-4 text-center text-sm font-medium">
      <div className="container mx-auto flex items-center justify-center gap-2 flex-wrap">
        <FiAlertTriangle className="w-5 h-5 flex-shrink-0" />
        <p className="flex-1 min-w-0">
          JEUX D'ARGENT ET DE HASARD PEUVENT ÊTRE DANGEREUX: PERTES D'ARGENT, CONFLITS FAMILIAUX, ADDICTION.
          RETROUVEZ NOS CONSEILS SUR{' '}
          <a
            href="https://www.joueurs-info-service.fr/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:no-underline font-semibold"
          >
            JOUEURS-INFO-SERVICE.FR
          </a>
          {' '}(09 74 75 13 13 - APPEL NON SURTAXÉ)
        </p>
      </div>
    </div>
  );
};

export default WarningBanner;

